<!-- 获取验证码组件 -->
<template>
  <div class=''>
    <input type="button" :value="inpVal" class="btn" v-if="seconds===60" @click="showVerify">
    <p class="btn start" v-else>{{seconds}}s</p>
    <van-overlay :show="showSlide">
      <div class="div_verify_machine">
        <div class="div_verify_title"><van-icon name="close" style="visibility: hidden;" />滑动以验证<van-icon name="close" @click="showSlide = false" /></div>
        <slide-verify :l="42"
              :r="10"
              :w="310"
              :h="155"
              @success="onSuccess"
              @fail="onFail"
              @refresh="onRefresh"
              :slider-text="text"
              ref="slideblock"
              :imgs="imageArray"
              ></slide-verify>
      </div>
    </van-overlay>
    <van-overlay :show="showProtocol" :lock-scroll="false">
      <div class="div_protocol_content" @click.stop>
        <div class="html_holder" v-html="dialogContent"></div>

        <div class="div_protocol_bottom_box">
          <div class="btn_confirm gray" @click="showProtocol = false">不同意</div>
          <div class="btn_confirm" @click="doSignCCBProtocol">同意</div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { reqSMSCode, reqBankVCode, getTDDevice, reqGetBankProtocol } from "@/api";
import { checkPhone } from "@/utils/verifyFunc";
import {mapState} from "vuex";
import sensors from 'sa-sdk-javascript'

export default {
  name: '',

  components: {},

  data () {
    return {
      timer: null,
      seconds: 60,
      flag: false,
      inpVal: '获取验证码',
      text: '向右滑',
      showSlide: false,
      imageArray: [
        require('../assets/imgs/other/img_verify_slide1.jpg'),
        require('../assets/imgs/other/img_verify_slide2.jpg'),
        require('../assets/imgs/other/img_verify_slide3.jpg'),
        require('../assets/imgs/other/img_verify_slide4.jpg'),
        require('../assets/imgs/other/img_verify_slide5.jpg'),
      ],
      dialogContent: '',
      showProtocol: false,
    };
  },
  
  computed: {
    ...mapState(['freeLoanData', 'appId', 'version', 'signTicket', 'userInfo']),
  },

  props: {
    codeType: {
      type: Object,
      default: () => {
        return {
          type: ''
        }
      }
    },
    reqData: {
      type: Object,
      default: () => {
        return {
          phoneNo: '',
          type: '01',
          channel: '',
          ip: '',
          device: ''
        }
      }
    },
    reqBankCardInfo: {
      type: Object,
      default: () => {
        return {
          cellNo: '',
          customerId: '',
          customerName: '',
          bankNo: '',
        }
      }
    },
    sensorsInfo: {
      type: Object,
      default: () => {
        return {
          business_type: '',
          current_page: '',
        }
      }
    }
  },

  computed: {
    ...mapState(["UA"])
  },

  created() {
  },

  methods: {
    getSMSCode() {
      console.log("---this.codeType:"+this.codeType.type)
      if (this.codeType.type) {//获取银行卡验证码
        if(!this.reqBankCardInfo.cellNo) {
          this.$toast("请填写银行卡预留手机号")
          return;
        }
        if(!checkPhone(this.reqBankCardInfo.cellNo)) {
          this.$toast("请填写正确的手机号")
          return;
        }
        // if(!this.reqBankCardInfo.bankNo) {
        //   this.$toast("请填写银行卡号")
        //   return;
        // }
        if(this.flag) {
          return;
        }
        if (this.codeType.bankName.includes('建设') || process.env.NODE_ENV === 'development') {
          this.processCCBProtocol('1', res => {
            this.dialogContent = res;
            this.showProtocol = true;
          });
        } else {
          this.doRealGetVerifyCode();
        }
      } else {//获取后台验证码
        let channelFrom = sessionStorage.getItem("channelFrom");
        this.reqData.channel = channelFrom;
        this.reqData.device = this.UA.substring(0, 450);
        // this.reqData.ip = localStorage.getItem("tdDeviceID");
        this.reqData.ip = '';
        reqSMSCode(this.reqData).then(res => {
          this.$emit('sendCode');
          this.$toast("验证码已发送")
          //神策上报
          sensors.track('GetAuthCode', {
            business_type: this.sensorsInfo.business_type,
            current_page: this.sensorsInfo.current_page,
            is_success: true,
            fail_reason: '',
          });
          this.flag = true;
          this.timer = setInterval(() => {
            this.seconds --;
            if(this.seconds <= 0) {
              clearInterval(this.timer);
              this.seconds = 60;
              this.flag = false;
              this.inpVal = '重发验证码'
            }
          }, 1000)
        }).catch(err => {
          let msg = err.data.resMessage
          if (msg && typeof msg === 'string' && msg.indexOf('验证码已发送') !== -1) {
            this.$emit('sendCode');
          }
          this.$toast(err.data.resMessage)
          //神策上报
          sensors.track('GetAuthCode', {
            business_type: this.sensorsInfo.business_type,
            current_page: this.sensorsInfo.current_page,
            is_success: false,
            fail_reason: err.data.resMessage,
          });
        })
      }
    },

    doRealGetVerifyCode() {
      reqBankVCode(this.reqBankCardInfo).then(res => {
        this.$emit('sendCode');
        this.$toast("验证码已发送")
        this.flag = true;
        sensors.track('BankCardVerify', {
          product_name: sessionStorage.getItem('tempProductName'),
          bank_number: this.reqBankCardInfo.bankNo,
          fill_type: '键入',
          bank_node: this.sensorsInfo.business_type,
          is_success: true,
        });
        this.timer = setInterval(() => {
          this.seconds --;
          if(this.seconds <= 0) {
            clearInterval(this.timer);
            this.seconds = 60;
            this.flag = false;
            this.inpVal = '重发验证码'
          }
        }, 1000)
      }).catch(err => {
        this.$toast(err.data.resMessage)
        sensors.track('BankCardVerify', {
          product_name: sessionStorage.getItem('tempProductName'),
          bank_number: this.reqBankCardInfo.bankNo,
          fill_type: '键入',
          bank_node: this.sensorsInfo.business_type,
          is_success: true,
          fail_reason: err.data.resMessage,
        });
      })
    },

    showVerify() {
      console.log("---this.codeType:"+this.codeType.type)
      if (this.codeType.type) {//获取银行卡验证码
        this.getSMSCode();
      } else {
        if(!this.reqData.phoneNo) {
          this.$toast("请填写手机号")
          return;
        }
        if(!checkPhone(this.reqData.phoneNo)) {
          this.$toast("请填写正确的手机号")
          return;
        }
        if(this.flag) {
          return;
        }
        this.$refs.slideblock.reset();
        this.showSlide = true;
      }
    },

    onSuccess() {
      var _this = this;
      setTimeout(function() {
        _this.showSlide = false;
        _this.getSMSCode();
      }, 500);
      
    },
    onFail() {
    },
    onRefresh() {
    },

    doSignCCBProtocol() {
      this.processCCBProtocol('2', res => {
        this.showProtocol = false;
        if (res !== '-1') {
          this.doRealGetVerifyCode();
        } else {
          this.$toast('签署协议失败，请稍后重试');
        }
      });
    },
    
    /**
     * @param bankNo 银行卡号
     * @param bankName 银行名称
     * @param type 1获取协议内容 2签署协议 3查询签署结果
     * @param callback 回调-1为失败，0或协议内容为成功
     */
    processCCBProtocol(type, callback) {
      let { freeLoanData } = this;
      let params = {
        userName: process.env.NODE_ENV === 'development' ? '刘新建' : freeLoanData.name,
        bankNo: process.env.NODE_ENV === 'development' ? '6214836099998333' : this.reqBankCardInfo.bankNo,
        bankName: process.env.NODE_ENV === 'development' ? '建设银行' : this.codeType.bankName,
        type: type,
        prodCode: process.env.NODE_ENV === 'development' ? 'PD0044' : freeLoanData.productCode,
        phone: this.reqBankCardInfo.cellNo,
        idNo: process.env.NODE_ENV === 'development' ? '412902197906291716' : freeLoanData.idNo,
      }
      console.info(params)
      reqGetBankProtocol(params).then(res => {
        if (type === '1') {
          callback(res.text);
        } else {
          callback('0');
        }
      }).catch(err => {
        callback('-1')
      })
    },
  },
}

</script>

<style lang='less' scoped>
  .btn {
    width:81px;
    line-height: 27px;
    background:rgba(227,189,136,1);
    border: 1px solid rgba(227,189,136,1);
    border-radius:14px;
    color: #78461C;
    font-size: 11px;
    text-align: center;
  }
  .start {
    color: #171717;
    border-color: #171717;
    background-color: transparent;
  }

    .div_verify_machine {
    padding: 10px;
    background-color: white;
  }

  .van-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.7);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .div_verify_title {
    margin-bottom: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

.div_protocol_content {
  width: 100%;
  height: 100vh;
  min-height: 100vh;
  /* min-height: calc(100vh - 46px); */
  background-color: #F5F5F5;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow-y: scroll;
}

.html_holder {
  width: 100%;
  height: 100%;
  padding: 10px 10px 47px;
  box-sizing: border-box;
  overflow-y: scroll;
  overflow-x: hidden;
}

.div_protocol_bottom_box {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  position: absolute;
  left: 0px;
  bottom: 46px;
  z-index: 1;
}

.btn_confirm {
  width: 30%;
  height: 48px;
  background-color: rgb(228, 184, 18);
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 19px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: white;
}

.gray {
  /*grayscale(val):val值越大灰度就越深*/
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%);
  filter: #CCCCCC;
}
</style>